export default __webpack_public_path__ + "static/media/609.2c6f7396.png";